import { ApplicationState } from '@app/store'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import ProjectedProfitPage from '../components/ProjectedProfitPage'
import {
  actionCreators,
  IProjectedProfitState,
  selectError,
  selectFilterText,
  selectIsLoading,
  selectItems,
  selectTotalItems,
} from '../modules/projectedProfit'

export default connect(
  createStructuredSelector<ApplicationState, IProjectedProfitState>({
    error: selectError(),
    filterText: selectFilterText(),
    isLoading: selectIsLoading(),
    items: selectItems(),
    totalItems: selectTotalItems(),
  }),
  actionCreators,
)(ProjectedProfitPage)
